module.exports = __webpack_public_path__ + "img/의약품.248d5ec8.png";